const PagedList = require('../entities/paged-list');

const leftOuterJoinPagedLists = (listA, listB, predicate = (a, b) => a === b) => {
  if (!listB || !listB.items || !listB.items.length) return listA;
  const newItems = listA.items.map(itemA => listB.items.find(itemB => predicate(itemA, itemB)) || itemA);
  return new PagedList(newItems, listA.page);
};

module.exports = leftOuterJoinPagedLists;